import { render, staticRenderFns } from "./handmadePrescriptionDetails.vue?vue&type=template&id=c32bcbf8"
import script from "./handmadePrescriptionDetails.vue?vue&type=script&lang=js"
export * from "./handmadePrescriptionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports